const smartWalletLocaleTl = {
    connecting: "Kumokonekta sa Smart Account",
    failedToConnect: "Hindi nagawa ang pagkonekta sa Smart Account",
    wrongNetworkScreen: {
        title: "Maling Network",
        subtitle: "Hindi konektado ang iyong wallet sa kinakailangang network",
        failedToSwitch: "Hindi nagawa ang pagpapalit ng network",
    },
};
export default smartWalletLocaleTl;
//# sourceMappingURL=tl.js.map